<template>
  <v-container fluid>
    <!-- DIALOG AGENCIES -->
    <v-dialog
      v-model="showAgencies"
      max-width="500px"
      persistent
    >
      <v-card>
        <v-flex class="text-xs-center" px-2 pt-3 pb-2>
          <h2>Seleccionar Agencia</h2>
        </v-flex>
        <agencies-tree :from-section="fromSection" />
        <v-flex d-flex pa-3 mx-2>
          <v-spacer></v-spacer>
          <v-btn
            color="error"
            @click="showAgencies = false"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="primary"
            @click="showAgencies = false"
            :disabled="agencySelected === null"
          >
            Aceptar
          </v-btn>
        </v-flex>
      </v-card>
    </v-dialog>
    <!-- DIALOG LOADING VEHICLE DATA -->
    <v-dialog
      v-model="showLoadingVehicleData"
      max-width="300"
      persistent>
      <v-card
        class="text-xs-center py-2"
        color="rgba(66, 66, 66, 0.7)"
        height="240">
        <h5 class="mt-3">
          Cargando Datos del Vehículo
        </h5>
        <v-flex class="tag-loading" mx-3 mt-1>
          {{ `ID: ${vehicleName}` }}
          <br>
          {{ `Placa: ${licensePlateEdit}` }}
          <br>
          {{ `Código/Sigla: ${codeEdit}` }}
        </v-flex>
        <v-progress-circular
          class="mt-4"
          :size="50"
          color="amber darken-1"
          indeterminate>
        </v-progress-circular>
      </v-card>
    </v-dialog>

    <v-layout>
      <!-- VEHICLES -->
      <v-flex 
        class="section-1 general-bg" 
        pb-1>
        <h3 class="text-xs-center pt-3">Vehículos</h3>
        <p class="text-xs-left px-4 pt-2 mt-3">
          Busque y/o seleccione un vehículo para <b class="edit-color">Editar</b> la información correspondiente.
        </p>

        <v-flex mt-3 px-4 pb-2>
          <v-text-field
            ref="search"
            v-model="searchVehicleValue"
            flat
            box
            prepend-inner-icon="search"
            color="white"
            label="Código/Sigla ó Placa"
            @keyup.enter="searchVehicle">
          </v-text-field>
        </v-flex>
        <!-- RESULT OF THE SEARCH -->
        <transition name="fade">
          <v-flex v-if="searchAction" pb-3>
            <v-flex d-flex align-center>
              <v-flex class="h7" pl-4>
                Vehículo hallado
              </v-flex>
              <v-flex class="text-xs-right" pr-3>
                <v-btn 
                  color="white"
                  flat
                  small
                  fab
                  @click="clearSearch">
                  <v-icon>close</v-icon>
                </v-btn>
              </v-flex>
            </v-flex>
            <transition name="fade">
              <v-flex v-if="searchVehicleResult.length > 0">
                <v-flex
                  mx-4
                  class="text-xs-center info-vehicle-r pointer-1"
                  align-center
                  d-flex
                  v-for="(vehicle, index) in searchVehicleResult"
                  :key="index"
                  @click="editVehicle(vehicle)">
                  <v-flex xs7 pr-2>
                    {{ vehicle.code }}
                  </v-flex>
                  <v-flex xs5 pr-4>
                    <v-flex class="plate-border">
                      {{ vehicle.licensePlate }}
                    </v-flex>
                  </v-flex>
                </v-flex>
                <br>
              </v-flex>
              <!-- NOT FOUND -->
              <v-flex v-else>
                <v-flex class="h7" pl-4 pb-3>
                  No se encontró ningun vehículo!
                </v-flex>
              </v-flex>
              </transition>
            <v-divider class="mx-4"></v-divider>
            </v-flex>
          </transition>
        
        <!-- TITLE OF LIST OF VEHICLES WITHOUT AGENCY -->
        <v-flex class="title-list-container" d-inline-flex mb-1 align-center py-1>
          <v-flex xs7 class="text-xs-right" mr-2>
            <h5>Listado de vehículos sin agencia asignada</h5>
          </v-flex>
          <v-flex xs5 pl-3 class="line-left">
            <h3>{{ vehiclesWithoutAgencyList.length }}</h3>
          </v-flex>
          <v-flex xs2>
            <v-icon>arrow_downward</v-icon>
          </v-flex>
        </v-flex>
        <!-- HEADER VEHICLES -->
        <v-flex 
          class="text-xs-center header-vehicle pr-3"
          align-center
          d-flex>
          <v-flex xs7 pr-2>
            Código/Sigla
          </v-flex>
          <v-flex xs5 pr-4>
            Placa
          </v-flex>
        </v-flex>
        <!-- VEHICLE LIST -->
        <v-flex 
          v-if="vehiclesWithoutAgencyList.length > 0"
          class="list-vehicles"
        >
          <v-flex
            class="text-xs-center info-vehicle pointer-1"
            align-center
            d-flex
            v-for="(vehicle, index) in vehiclesWithoutAgencyList"
            :key="index"
            @click="editVehicle(vehicle)">
            <v-flex xs7 pr-2>
              {{ vehicle.code }}
            </v-flex>
            <v-flex xs5 pr-4>
              <v-flex class="plate-border">
                {{ vehicle.licensePlate }}
              </v-flex>
            </v-flex>
          </v-flex>
        </v-flex>
        <v-flex v-else class="text-xs-center" pt-3>
          <v-avatar
            size="150px"
            color="grey darken-4">
            <v-icon size="100px" color="grey darken-3">check</v-icon>
          </v-avatar>
        </v-flex>
      </v-flex>
      
      <!-- FORM CRUD VEHICLE -->
      <v-flex 
        class="section-2 general-bg" 
        pt-3 
        pl-5 
        pb-4>
        <v-flex>
          <v-flex class="title-2" mr-3>
            <h2> {{ title2 }}</h2>
          </v-flex>
          <v-flex v-if="!showLoadingVehicleData && vehicleName !== ''" class="tag-id">
            {{ `Código/Sigla: ${vehicleData.code ? vehicleData.code : '----' } | Placa: ${vehicleData.licensePlate ? vehicleData.licensePlate : '----'}` }}
          </v-flex>
        </v-flex>
        <p v-if="vehicleName !== ''" class="pl-1 pr-3 pt-2">
          {{ message2 }} <br>Por favor llene todos los campos solicitados
        </p>
        <p v-else class="pl-1 pr-3 pt-2">
          {{ message2 }} <br>Por favor elija un vehículo de la lista para cargar sus datos.
        </p>
        <!-- ALERT MESSAGE -->
        <v-flex pr-5>
          <v-alert
            v-model="showErrorMessage"
            type="error"
            color="red darken-1"
            dismissible
            transition="scale-transition">
            {{ errorMessage }}
          </v-alert>
        </v-flex>
        <!-- SUCCESS MESSAGE -->
        <!-- FOR UPDATE -->
        <v-flex pr-5>
          <v-alert
            v-model="showSuccessMessageUp"
            type="success"
            color="amber darken-1 grey--text text--darken-3"
            dismissible 
            transition="scale-transition">
            {{ successMessageUp }}
          </v-alert>
        </v-flex>
        <!-- FULL CONTAINER -->
        <v-flex
          v-if="!showLoadingVehicleData && vehicleName !== ''"
          class="binnacle-cotainer-main"
          mt-4
        >
          <v-flex v-if="currentDeviceVehicle !== null">
            <!-- OPERATIONAL STATE -->
            <v-flex
              class="container-expansion"
              mr-5
              pa-1
            >
              <v-expansion-panel>
                <v-expansion-panel-content>
                  <template v-slot:header>
                    <div>Condición Vehículo Actual: <b>{{ vehicleData.status.translatedName }}</b></div>
                  </template>
                  <v-flex
                    class="container-operational-state"
                    pl-3
                    pb-3
                  >
                    <v-flex pt-2>
                      <h5>Condición Vehículo</h5>
                    </v-flex>
                    <v-flex d-flex align-center pt-1>
                      <v-flex xs6>
                        <v-flex class="current-status" pa-1 mr-4>
                          <h6>Condición Actual: <b>{{ vehicleData.status.translatedName }}</b></h6>
                        </v-flex>
                        <v-flex
                          v-if="validStatusSelected.key !== '' && validStatusSelected.key !== vehicleData.status.name"
                          class="edit-status"
                          pa-1
                          mr-4
                          mt-1
                        >
                          <h6>Condición a Cambiar: <b>{{ validStatus.value }}</b></h6>
                        </v-flex>
                      </v-flex>
                      <v-flex xs6 pr-3>
                        <v-select
                          ref="selectConditions"
                          v-model="validStatusSelected.key"
                          label="Condiciones"
                          :items="validStatuses"
                          item-text="value"
                          item-value="key"
                          return-object
                          color="amber darken-1primary"
                          clearable
                          @change="conditionChange"
                        ></v-select>
                        <v-select
                          v-if="validStatusSelected.key === 'not_operational'"
                          v-model="statusReason.name"
                          label="Causas"
                          :items="defaultReasons"
                          item-text="name"
                          item-value="name"
                          color="amber darken-1primary"
                          clearable
                        ></v-select>
                        <v-text-field
                          v-if="statusReason.name === 'Otra' && validStatusSelected.key === 'not_operational'"
                          v-model="otherReason"
                          name="otherReason"
                          label="Otra Causa"
                          color="amber darken-1primary"
                          required
                          :disabled="otherReasonDisabled"
                        >
                        </v-text-field>
                      </v-flex>
                    </v-flex>
                    <!-- TIME -->
                    <v-divider class="mt-3 mr-3"></v-divider>
                    <v-flex d-flex pt-3 pr-3>
                      <v-flex d-inline-flex align-center xs6 class="current-status" mr-3 pl-1 pt-2>
                        <v-flex class="icon-width" pr-2>
                          <v-icon color="#424242">event</v-icon>
                        </v-flex>
                        <v-flex>
                          <v-flex class="caption">Codición Actual Desde:</v-flex>
                          <b>{{ vehicleData.status.time | filterFullDate }}</b>
                        </v-flex>
                      </v-flex>
                      <v-flex xs6>
                        <v-menu
                          lazy
                          ref="menu0"
                          v-model="menuDateSelectedCondition"
                          transition="scale-transition"
                          :close-on-content-click="false"
                          :return-value.sync="dates0"
                          offset-y
                          origin="top"
                          color="white"
                          :disabled="validStatusSelected.key === vehicleData.status.name"
                        >
                          <template v-slot:activator="{ on }">
                            <v-combobox
                              v-model="dates0"
                              multiple
                              chips
                              small-chips
                              label="Nueva Condición Desde"
                              placeholder="Fecha"
                              prepend-icon="event"
                              readonly
                              color="white"
                              v-on="on"
                            >
                            </v-combobox>
                          </template>
                          <v-date-picker 
                            v-model="dates0"
                            multiple
                            no-title
                            scrollable
                            :first-day-of-week="1"
                            locale="es-sp"
                            :allowed-dates="allowedDates0"
                            color="blue accent-3"
                            @input="changesDate0"
                          >
                            <v-spacer></v-spacer>
                            <v-btn color="error" @click="menuDateSelectedCondition = false">Cancelar</v-btn>
                            <v-btn color="primary" @click="acceptDate0">Aceptar</v-btn>
                          </v-date-picker>
                        </v-menu>
                      </v-flex>
                    </v-flex>
                    <v-divider class="mt-3 mr-3"></v-divider>
                    <!-- OBSERVATIONS | TICKET -->
                    <!-- IF -->
                    <v-flex v-if="validStatusSelected.key === vehicleData.status.name" pt-3 pr-3>
                      <v-text-field
                        v-model="observations"
                        name="observations"
                        label="Observaciones"
                        color="amber darken-1primary"
                        :disabled="validStatusSelected.key === vehicleData.status.name"
                      >
                      </v-text-field>
                      <v-text-field
                        v-model="ticket"
                        name="ticket"
                        label="Ticket Asociado"
                        color="amber darken-1primary"
                        :disabled="validStatusSelected.key === vehicleData.status.name"
                      >
                      </v-text-field>
                    </v-flex>
                    <!-- ELSE -->
                    <v-flex v-else pt-3 pr-3>
                      <v-text-field
                        v-model="newObservations"
                        name="observations"
                        label="Nuevas Observaciones"
                        color="amber darken-1primary"
                      >
                      </v-text-field>
                      <v-text-field
                        v-model="newTicket"
                        name="ticket"
                        label="Nuevo Ticket Asociado"
                        color="amber darken-1primary"
                      >
                      </v-text-field>
                    </v-flex>
                    <v-flex d-flex pr-5>
                      <v-spacer></v-spacer>
                      <v-spacer></v-spacer>
                      <v-spacer></v-spacer>
                      <v-btn
                        color="amber darken-1 grey--text text--darken-3"
                        left
                        :disabled="!validUpdateVehicleStatus"
                        @click="updateVehicleStatus"
                        :loading="$loading.isLoading('updateVehicleCondition')"
                      >
                        <v-icon left>backup</v-icon>
                        Actualizar Condición
                      </v-btn>
                    </v-flex>
                  </v-flex>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-flex>
            <!-- FORMS FOR THE VEHICLE DATA -->
            <v-flex>
              <!-- FORM 1 UP -->
              <v-flex
                class="text-xs-left"
                pt-2
                pb-3>
                <!-- COLUMN 1 -->
                <v-flex d-flex>
                  <v-flex class="text-xs-center" xs4 pt-3>
                  <!-- AVATAR -->
                    <v-avatar
                      size="100px"
                      color="grey">
                      <v-icon
                        v-if="vehicleTypes.get(vehicleData.vehicleType) === 'MOTOCICLETA'" 
                        size="70px"
                        color="grey lighten-2">
                        motorcycle
                      </v-icon>
                      <v-icon 
                        v-else size="70px"
                        color="grey lighten-2">
                        directions_car
                      </v-icon>
                    </v-avatar>
                    <!-- ESN / DEVICE ID -->
                    <v-flex my-3>
                      ID dispositivo
                      <br>
                      <b>{{ deviceIDC ? deviceIDC : '............' }}</b>
                    </v-flex>
                    <v-flex my-3>
                      <v-flex>
                        <v-icon color="success" class="pt-1">access_time</v-icon>
                        Activado
                      </v-flex>
                      <v-flex>
                        <b>{{ activationTime }}</b>
                      </v-flex>
                    </v-flex>
                  </v-flex>
                  <!-- COLUMN 2 -->
                  <v-flex justify-start xs8 pr-5>
                    <v-form ref="form1" v-model="valid1" lazy-validation @submit.prevent>
                      <!-- VEHICLE TYPE -->
                      <v-text-field
                        :disabled="notEditable"
                        v-model="vehicleType"
                        name="vehicle-type"
                        label="Tipo de vehículo"
                        color="white">
                      </v-text-field>
                      <!-- CODE ABBREVIATION -->
                      <v-text-field
                        :disabled="notEditable && !!codeAbbreviation"
                        v-model="codeAbbreviation"
                        name="code"
                        label="Código/Sigla"
                        color="white"
                        required>
                      </v-text-field>
                      <!-- LICENSE PLATE -->
                      <v-text-field
                        :disabled="notEditable"
                        v-model="licensePlate"
                        name="plate"
                        label="Placa"
                        color="white">
                      </v-text-field>
                      <!-- AGENCY -->
                      <v-flex pt-2 class="agency-style" d-flex aling-center>
                        <v-flex xs9>
                        <span class="h5-ext">
                          {{ `Agencia actual: ${vehicleDataTemp.agencyId ? agenciesMap.get(vehicleDataTemp.agencyId).name : ''}` }}
                          </span>
                        <i><h5>
                          {{ `Agencia a cambiar: ${!!agencySelected ? agencySelected.name : ''}` }}
                          </h5></i>
                          <v-btn
                            color="amber darken-1 grey--text text--darken-3"
                            small
                            @click="showAgencies = true"
                          >
                            <v-icon left>business</v-icon>
                            Seleccionar
                          </v-btn>
                        </v-flex>
                        <!-- <v-flex xs3 class="text-xs-right">
                          <v-icon size="50">play_arrow</v-icon>
                        </v-flex> -->
                      </v-flex>
                    </v-form>
                  </v-flex>

                </v-flex>
                
              </v-flex>
              <v-divider class="mr-5"></v-divider>
              <!-- FORM 2 BELOW  -->
              <v-flex pt-3>
                <v-form ref="form2" v-model="valid2" lazy-validation @submit.prevent>
                  <!--  ROW 1  -->
                  <v-flex d-flex pr-5>
                      <!-- BRAND -->
                      <v-flex xs6 pr-3>
                        <v-text-field
                          :disabled="notEditable"
                          v-model="brand"
                          label="Marca"
                          color="white">
                        </v-text-field>
                      </v-flex>
                    <!-- MODEL -->
                    <v-flex xs6>
                      <v-text-field
                        xs6
                        v-model="model"
                        v-if="!!model"
                        :disabled="notEditable"
                        name="vehicle-model"
                        label="Modelo"
                        color="white">
                      </v-text-field>
                      <v-autocomplete
                        v-else
                        v-model="model"
                        :items="modelsYear"
                        label="Modelo"
                        color="white"/>
                    </v-flex>

                  </v-flex>
                  <!--  ROW 2  -->
                  <v-flex d-flex pr-5>
                      <!-- REFERENCE -->
                      <v-flex xs6 pr-3>
                        <v-text-field
                          :disabled="notEditable && !!reference"
                          v-model="reference"
                          name="reference"
                          label="Referencia"
                          color="white"
                          required>
                        </v-text-field>
                      </v-flex>
                      <!-- COLOR -->
                      <v-flex xs6>
                        <v-text-field
                          :disabled="notEditable && !!color"
                          v-model="color"
                          name="vehicle-color"
                          label="Color"
                          color="white"
                          :rules="colorRules">
                        </v-text-field>
                      </v-flex>
                  </v-flex>
                  <!--  ROW 3  -->
                  <v-flex d-flex pr-5>
                    <!-- CUBIC CAPACITY -->
                    <v-flex xs6 pr-3>
                      <v-text-field
                        :disabled="notEditable && !!engineDisplacement"
                        v-model="engineDisplacement"
                        name="engine-displacement"
                        label="Cilindraje"
                        color="white"
                        required>
                      </v-text-field>
                    </v-flex>
                    <!-- GAS TYPE -->
                      <!-- :rules="selectRules"/> -->
                    <v-flex xs6>
                      <v-autocomplete
                        :disabled="notEditable && !!fuelType"
                        v-model="fuelType"
                        :items="fuelTypes"
                        label="Tipo de combustible"
                        color="white"/>
                    </v-flex>
                  </v-flex>
                  <!--  ROW 4  -->
                  <v-flex d-flex pr-5>
                      <!-- INITIAL ODOMETER -->
                      <v-flex xs4 pr-3>
                      <v-text-field
                        :disabled="notEditable"
                        v-model="initialOdometer"
                        name="initial-dometer"
                        label="Odometro Inicial"
                        color="white">
                      </v-text-field>
                      </v-flex>
                      <!-- ODOMETER -->
                      <v-flex xs4 pr-3>
                      <v-text-field
                        :disabled="notEditable"
                        v-model="odometer"
                        name="odometer"
                        label="Odometro dispositivo actual"
                        color="white"
                        required>
                      </v-text-field>
                      </v-flex>
                      <!-- TOTAL ODOMETER -->
                      <v-flex xs4>
                      <v-text-field
                        :disabled="notEditable"
                        v-model="totalOdometer"
                        name="total-odometer"
                        label="Odometro Total"
                        color="white"
                        required>
                      </v-text-field>
                      </v-flex>
                  </v-flex>
                  <!--  ROW 5 --> 
                  <!-- CHIP FUEL -->
                  <v-flex d-inline-flex align-center>
                    <v-flex class="chip-info-style">Chip Combustible?</v-flex>
                    <v-radio-group
                      v-model="chipYesNot"
                      class="chip-info-style">
                      <v-radio
                        v-for="(n, index) in yesNot"
                        :key="index"
                        :label="n"
                        :value="n"
                        color="amber darken-1"
                        @change="chipSerialChange"
                      ></v-radio>
                    </v-radio-group>
                    <v-flex class="chip-info-style-text">
                      <!-- CHIP SERIAL -->
                      <v-text-field
                        v-if="chipSerialSelected"
                        v-model="chipSerial"
                        name="chip-serial"
                        label="Serial Chip"
                        color="white"
                        required
                        :rules="chipSerialRules"
                        @keypress="isAlphaNumeric">
                      </v-text-field>
                    </v-flex>
                  </v-flex>
                  <!--  ROW 6 -->
                  <!-- INFO DRIVER -->
                  <v-flex mr-5>
                    <v-textarea
                      v-model='driverData'
                      outline
                      rows="3"
                      color="white"
                      name="info-driver"
                      label="Datos conductor asignado"
                      value="">
                    </v-textarea>
                  </v-flex>
                </v-form>

              </v-flex>
              <!-- BUTTON -->
              <v-flex class="text-xs-center" pt-1>
                <v-flex
                  class="text-xs-center"
                  pr-5
                  mr-5
                  pl-3>
                  <v-btn
                    block
                    color="amber darken-1 grey--text text--darken-3"
                    left
                    @click="updateVehicleDataPre"
                    :loading="$loading.isLoading('Updating vehicle')">
                    <v-icon left>backup</v-icon>
                    Actualizar
                  </v-btn>
                </v-flex>
              </v-flex>
            </v-flex>
          </v-flex>
          <!-- CURRENT DEVICE NULL -->
          <v-flex v-else>
            <v-flex class="text-xs-center" pt-3>
            <!-- AVATAR -->
              <v-avatar
                size="100px"
                color="grey">
                <v-icon
                  v-if="vehicleTypes.get(vehicleData.vehicleType) === 'MOTOCICLETA'" 
                  size="70px"
                  color="grey lighten-2">
                  motorcycle
                </v-icon>
                <v-icon
                  v-else size="70px"
                  color="grey lighten-2">
                  directions_car
                </v-icon>
              </v-avatar>
              <!-- ESN / DEVICE ID -->
              <v-flex my-3>
                ID dispositivo
                <br>
                <b>............</b>
                <br>
                <p>El vehículo no tiene dispositivo asociado en éste momento.</p>
              </v-flex>
            </v-flex>
          </v-flex>
        </v-flex>
        <!-- BIG ICON CAR -->
        <v-flex v-else class="text-xs-center big-icon" pt-5>
          <v-avatar
            size="400px"
            color="grey darken-4">
            <v-icon v-if="showLoadingVehicleData" size="280px" color="grey darken-3">cloud_download</v-icon>
            <v-icon v-else size="280px" color="grey darken-3">sort</v-icon>
          </v-avatar>
        </v-flex>
      </v-flex>
      <!-- STATES & DEVICES -->
      <v-flex
        class="section-4 general-bg"
        column
        pb-4
        ml-2
      >
        <v-flex pl-4 pt-3>
          <h3>Historial</h3>
        </v-flex>
        <v-flex v-if="!showLoadingVehicleData && vehicleName !== ''">
          <v-flex
            class="tag-id-mini"
            ml-4
          >
            {{ `Código/Sigla: ${vehicleData.code ? vehicleData.code : '----' } | Placa: ${vehicleData.licensePlate ? vehicleData.licensePlate : '----'}` }}
          </v-flex>
          <v-flex class="historical-cotainer-main">
            <!-- STATES -->
            <v-flex px-4 pt-3>
              <v-flex class="h7 font-weight-bold">Condiciones del vehículo anteriores</v-flex>
              <p>
                Lista de las condiciones anteriores que alguna vez tuvo asignadas el vehículo seleccionado.
              </p>
              <v-flex v-if="statuses.length > 0">
                <v-flex d-flex pa-1>
                  <v-flex class="col-h-2 font-weight-bold">
                    Condición
                  </v-flex>
                  <v-flex class="col-h-2 text-xs-center font-weight-bold">
                    Razón
                  </v-flex>
                  <v-flex class="col-h-3 text-xs-center font-weight-bold">
                    Desde
                  </v-flex>
                  <v-flex class="col-h-3 text-xs-center font-weight-bold">
                    Fecha Registro
                  </v-flex>
                </v-flex>
                <v-flex class="histories-container">
                  <v-flex 
                    v-for="(vehicleStatus, index) in statuses"
                    :key="`${vehicleStatus.id}-${index}`"
                    :class="[index % 2 ? '' : rowbg]"
                  >
                    <v-flex d-flex pa-1 align-center>
                      <v-flex class="col-h-2 caption">
                        {{ statusesMap.get(vehicleStatus.name) }}
                      </v-flex>
                      <v-flex class="col-h-2 text-xs-center caption">
                        {{ vehicleStatus.reason }}
                      </v-flex>
                      <v-flex class="col-h-3 text-xs-center caption">
                        {{ vehicleStatus.time | filterDate }}
                      </v-flex>
                      <v-flex class="col-h-3 text-xs-center caption">
                        {{ vehicleStatus.createdAt | filterFullDate }}
                      </v-flex>
                    </v-flex>
                  </v-flex>
                </v-flex>
              </v-flex>
              <v-flex class="message-historial" pa-2 v-else>
                <p>Sin historial, el vehículo seleccionado solo ha tenido la condición actual.</p>
              </v-flex>
            </v-flex>
            <!-- DEVICES -->
            <v-flex px-4 pt-5>
              <v-flex class="h7 font-weight-bold">Dispositivos anteriores</v-flex>
              <p>
                Lista de los dispositivos asociados que alguna vez tuvo instalados el vehículo seleccionado.
              </p>
              <v-flex v-if="devices.length > 0">
                <v-flex d-flex pa-1>
                  <v-flex class="col-h-1 font-weight-bold">
                    Dispositivo
                  </v-flex>
                  <v-flex class="col-h-1 text-xs-center font-weight-bold">
                    Operación
                  </v-flex>
                  <v-flex class="col-h-1 text-xs-center font-weight-bold">
                    Fecha
                  </v-flex>
                </v-flex>
                <v-flex class="histories-container">
                  <v-flex
                    v-for="(vehicleDevice, index) in devices"
                    :key="`${vehicleDevice.id}-${index}`"
                    :class="[index % 2 ? '' : rowbg]"
                  >
                    <v-flex d-flex pa-1 align-center>
                      <v-flex class="col-h-1 caption">
                        {{ vehicleDevice.esn }}
                      </v-flex>
                      <v-flex class="col-h-1 caption text-xs-center">
                        {{ operationsMap.get(vehicleDevice.pivot.operation) }}
                      </v-flex>
                      <v-flex class="col-h-1 caption text-xs-center">
                        {{ vehicleDevice.pivot.activationTimestamp | filterFullDate }}
                      </v-flex>
                    </v-flex>
                  </v-flex>
                </v-flex>
              </v-flex>
              <v-flex class="message-historial" pa-2 v-else>
                <p>Sin historial, el vehículo seleccionado solo ha tenido el dispositivo actual</p>
              </v-flex>
            </v-flex>
          </v-flex>
        </v-flex>
        <!-- BIG ICON CAR -->
        <v-flex v-else class="text-xs-center big-icon" pl-5 pt-5>
          <v-avatar
            size="400px"
            color="grey darken-4">
            <v-icon v-if="showLoadingVehicleData" size="280px" color="grey darken-3">cloud_download</v-icon>
            <v-icon v-else size="280px" color="grey darken-3">sort</v-icon>
          </v-avatar>
        </v-flex>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
// import Vue from 'vue'
import * as types from '../store/mutations-types'

import {mapActions, mapGetters} from 'vuex'
import AgenciesTree from '@/components/AgenciesTree'
import { agenciesMixin } from '../mixins/agenciesMixin.js'

import { statusesMap } from '../utils/statuses'
import { operationsMap } from '../utils/operations'

export default {
  name: 'vehicle-crud',
  components: {
    AgenciesTree
  },
  mixins: [agenciesMixin],
  data() {
    return {
      currentDeviceVehicle: null,
      rowbg: 'bg-row',
      statusesMap,
      operationsMap,
      showAgencies: false,
      otherReasonDisabled: false,
      newObservations: '',
      newTicket: '',
      dates0: [],
      menuDateSelectedCondition: false,
      validStatusSelected: {
        key: '',
        value: ''
      },
      validStatus: {},
      otherReason: '',
      statusReason: {
        name: ''
      },
      searchAction: false,
      searchVehicleResult: [],
      searchVehicleValue: null,
      notEditable: true,
      radioGroup: '',
      chipSerialSelected: false,
      yesNot: ['Si', 'No'],
      licensePlateEdit: '',
      codeEdit: '',
      superA: false,
      selectedCRUD: 'edit',
      fromSection: 'crud',
      valid1: true,
      valid2: true,
      vehicleName: '',
      title2: 'Bitácora del Vehículo',
      message2: 'En ésta sección podrá editar el vehículo seleccionado.',
      fuelTypes: [
        'Diesel',
        'Gasolina'
        // 'Gas'
      ],
      licensePlateTemp: '',
      maxModel: 4,
      showErrorMessage: false,
      errorMessage: ''
    }
  },
  watch: {
    vehicleData(newValue, oldValue) {
      // console.log('WATCH vehicleData: ', newValue)
      const data = { key: newValue.status.name, value: newValue.status.translatedName }

      // console.log('NEW VALUE', newValue)
      // console.log('OLD VALUE', oldValue)
      this.currentDeviceVehicle = newValue.currentDevice

      if (newValue.status !== oldValue.status) {
        // console.log('WATCH vehicleData -> RESETING DATA')
        this.otherReasonDisabled = false
        this.newObservations = ''
        this.newTicket = ''
        this.dates0 = []
        this.menuDateSelectedCondition = false
        this.validStatusSelected = {
          key: '',
          value: ''
        }
        this.validStatus = {}
        this.otherReason = ''
        this.statusReason = {
          name: ''
        }
      }

      this.$nextTick(() => {
        this.validStatus.key = data.key
        // this.$refs.selectConditions = data.value
        // Vue.set(this.validStatus, 'value', data.value)
        // Vue.set(this.validStatus, 'key', data.key)
        this.validStatusSelected.key = data.key
        this.validStatusSelected.value = data.value
        if (newValue.status.name === 'not_operational') {
          this.statusReason.name = newValue.status.reason !== null ? newValue.status.reason : ''
          if (this.statusReason.name === 'Otra') {
            this.otherReason = newValue.status.anotherReason
            this.otherReasonDisabled = true
          }
        }
      })
    }
  },
  computed: {
    ...mapGetters([
      'statuses',
      'devices',
      'validStatuses',
      'defaultReasons',
      'vehiclesWithoutAgency',
      'getFilteredVehicles',
      'getVehicles',
      'nameRules',
      'selectRules',
      'modelRules',
      'colorRules',
      'vehicleData',
      'successMessageUp',
      'agencySelected',
      'getSelectedVehicle',
      'lastPositionsInit',
      'showLoadingVehicleData',
      'agenciesMap',
      'vehicleTypes',
      'chipSerialRules',
      'vehicleDataTemp',
      'searchingVehicle'
    ]),
    ...mapGetters({
      profile: 'auth/getProfile',
      role: 'auth/role'
    }),
    // validStatus: {
    //   get() {
    //     return { key: this.vehicleData.status.name, value: this.vehicleData.status.translatedName }
    //   },
    //   set(value) {
    //     console.log('validStatus ', value)
    //     this.validStatusSelected.value = value
    //     return value
    //   }
    // },
    // statuses() {
    //   let result = {}
    //   if (this.vehicleData) {
    //     // let _obj = {}
    //     // let statuses = Object.assign(_obj, this.vehicleData.statuses)
    //     let statuses = Object.create(this.vehicleData.statuses)
    //     // let statuses = { ...this.vehicleData.statuses }
    //     console.log('statuses', statuses)
    //     // result = [].sort.call(statuses, function(a, b) {
    //     result = statuses.sort(function(a, b) {
    //       const textA = a.time
    //       const textB = b.time
    //       return (textA > textB) ? -1 : (textA < textB) ? 1 : 0
    //     })
    //   }
    //   console.log('result S', result)
    //   return result
    // },
    // devices() {
    //   let result = {}
    //   if (this.vehicleData) {
    //     let _obj = {}
    //     let devices = Object.assign(_obj, this.vehicleData.devices)
    //     console.log('devices', devices)
    //     result = [].slice.call(devices).sort(function(a, b) {
    //       const textA = a.pivot.activationTimestamp
    //       const textB = b.pivot.activationTimestamp
    //       return (textA > textB) ? -1 : (textA < textB) ? 1 : 0
    //     })
    //   }
    //   console.log('result D', result)
    //   return result
    // },
    validUpdateVehicleStatus() {
      let value = false
      if (this.validStatusSelected.key !== this.vehicleData.status.name) {
        value = true
        // console.log(this.validStatusSelected.key === 'not_operational' && this.statusReason.name !== '' && this.dates0.length === 1)
        // console.log('statusReason: ', this.statusReason.name)
        if (
          this.validStatusSelected.key === 'not_operational' &&
          this.statusReason.name !== '' &&
          this.dates0.length === 1) {
          if (this.statusReason.name === 'Otra') value = this.otherReason !== ''
          else value = true
        } else if (
          (this.validStatusSelected.key === 'operational' || this.validStatusSelected.key === 'to_identify') &&
          this.dates0.length === 1) value = true
        else value = false
      }
      return value
    },
    observations: {
      get() {
        return this.vehicleData.status.observations
      },
      set(value) {
        const data = {
          key: 'observations',
          value: value
        }
        this.addVehicleDataTemp(data)
      }
    },
    ticket: {
      get() {
        return this.vehicleData.status.ticket
      },
      set(value) {
        const data = {
          key: 'ticket',
          value: value
        }
        this.addVehicleDataTemp(data)
      }
    },
    vehiclesWithoutAgencyList() {
      let result = []
      if (this.role.length === 0) result = this.lastPositionsInit.filter(item => item.agencyId === null)
      else if (this.role.length > 1) result = this.vehiclesWithoutAgency
      return result
    },
    driverData: {
      get() {
        return this.vehicleData.driverData
      },
      set(value) {
        const data = {
          key: 'driverData',
          value: value
        }
        this.addVehicleDataTemp(data)
      }
    },
    chipYesNot: {
      get() {
        if (this.vehicleData.fuelChip === null) {
          this.chipSerialSelected = false
          return 'No'
        } else {
          this.chipSerialSelected = true
          this.setChipSerialYesNot(true)
          return 'Si'
        }
      },
      set(value) {
        // console.log('Value', value)
        const data = value === 'Si'
        // console.log('Data', data)
        this.setChipSerialYesNot(data)
      }
    },
    chipSerial: {
      get() {
        return this.vehicleData.fuelChip
      },
      set(value) {
        const data = {
          key: 'fuelChip',
          value: value
        }
        this.addVehicleDataTemp(data)
      }
    },
    modelsYear() {
      const models = []
      for (let index = 1980; index < 2019; index++) {
        models.push(index)
      }
      return models
    },
    deviceIDC() {
      if (this.vehicleData.currentDevice) return this.vehicleData.currentDevice.esn
      else return null
    },
    activationTime() {
      if (this.vehicleData.currentDevice) return this.vehicleData.currentDevice.pivot.activationTimestamp
      else return '..........'
    },
    engineDisplacement: {
      get() {
        return this.vehicleData.engineDisplacement ? this.vehicleData.engineDisplacement : ''
      },
      set(value) {
        const data = {
          key: 'engineDisplacement',
          value: value
        }
        this.addVehicleDataTemp(data)
      }
    },
    codeAbbreviation: {
      get() {
        return this.vehicleData.code
      },
      set(value) {
        const data = {
          key: 'code',
          value: value
        }
        this.addVehicleDataTemp(data)
      }
    },
    licensePlate: {
      get() {
        return this.vehicleData.licensePlate
      },
      set(value) {
        const data = {
          key: 'licensePlate',
          value: value
        }
        this.addVehicleDataTemp(data)
      }
    },
    vehicleType: {
      get() {
        return this.vehicleTypes.get(this.vehicleData.vehicleType)
      },
      set(value) {
        const data = {
          key: 'vehicleType',
          value: value
        }
        this.addVehicleDataTemp(data)
      }
    },
    brand: {
      get() {
        return this.vehicleData.brand
      },
      set(value) {
        const data = {
          key: 'brand',
          value: value
        }
        this.addVehicleDataTemp(data)
      }
    },
    model: {
      get() {
        return this.vehicleData.model
      },
      set(value) {
        const data = {
          key: 'model',
          value: value
        }
        this.addVehicleDataTemp(data)
      }
    },
    color: {
      get() {
        return this.vehicleData.color
      },
      set(value) {
        const data = {
          key: 'color',
          value: value
        }
        this.addVehicleDataTemp(data)
      }
    },
    fuelType: {
      get() {
        return this.vehicleData.fuelType
      },
      set(value) {
        const data = {
          key: 'fuelType',
          value: value
        }
        this.addVehicleDataTemp(data)
      }
    },
    initialOdometer: {
      get() {
        return this.vehicleData.initialOdometer
      },
      set(value) {
        const data = {
          key: 'initialOdometer',
          value: value
        }
        this.addVehicleDataTemp(data)
      }
    },
    odometer: {
      get() {
        if (this.vehicleData.currentDevice) return this.vehicleData.currentDevice.pivot.odometer
        else return '0'
      },
      set(value) {
        const data = {
          key: 'currentDevice.pivot.odometer',
          value: value
        }
        this.addVehicleDataTemp(data)
      }
    },
    totalOdometer: {
      get() {
        if (this.vehicleData.currentDevice) { 
          return this.vehicleData.initialOdometer + this.vehicleData.currentDevice.pivot.odometer + this.vehicleData.lastPosition.metadata.odometer
        } else return this.vehicleData.initialOdometer
      },
      set(value) {
        const data = {
          key: 'currentDevice.pivot.odometer',
          value: value
        }
        this.addVehicleDataTemp(data)
      }
    },
    reference: {
      get() {
        return this.vehicleData.reference
      },
      set(value) {
        const data = {
          key: 'reference',
          value: value
        }
        this.addVehicleDataTemp(data)
      }
    },
    showSuccessMessageUp: {
      get() {
        return this.$store.state.vehicles.showSuccessMessageUp
      },
      set(value) {
        const data = {
          nameA: 'showSuccessMessageUp',
          nameM: 'successMessageUp',
          show: value,
          message: ''
        }
        this.$store.commit(types.CONTROL_MESSAGE, data)
      }
    }
  },
  methods: {
    ...mapActions([
      'updateVehicleCondition',
      'fetchAgenciesAction',
      'addVehicleData',
      'updateVehicleData',
      'selectVehicle',
      'agencySelectedAction',
      'fetchVehicleById',
      'setChipSerialYesNot',
      'addVehicleDataTemp',
      'searchVehicleAction',
      'setLogHistoryFront'
    ]),
    allowedDates0(date) {
      const currentCondition = this.$moment(this.vehicleData.status.time)
      let today = this.$moment.now()
      let datesResult = this.$moment(date).isBefore(today) && this.$moment(date).isAfter(currentCondition)
      today = this.$moment(today).format('YYYY-MM-DD')

      if (this.dates0.length === 1) datesResult = date === this.dates0[0]

      return datesResult
    },
    changesDate0() {
      // console.log('CHANGE DATE')
      if (this.dates0.length === 0) {
      }
    },
    acceptDate0() {
      this.$refs.menu0.save(this.dates0)
    },
    conditionChange(e) {
      // console.log('conditionChange: ', e)
      if (e !== undefined) {
        this.validStatus = e
        this.validStatusSelected.key = e.key
        this.validStatusSelected.value = e.value
        // console.log('translatedName: ', this.vehicleData.status.translatedName)
        // console.log('validStatusSelected: ', this.validStatusSelected.key)
        // console.log('validStatus: ', this.validStatus.value)
        if (this.validStatusSelected.key === this.vehicleData.status.name) {
          this.dates0 = []
          this.observations = this.vehicleData.status.observations
          this.ticket = this.vehicleData.status.ticket
        }
      }
    },
    updateVehicleStatus() {
      let reason
      if (this.validStatusSelected.key === 'operational' || this.validStatusSelected.key === 'to_identify') reason = ''
      else reason = this.statusReason.name

      const data = {
        id: this.vehicleData.id,
        name: this.validStatusSelected.key,
        translatedName: this.validStatusSelected.value,
        observations: this.newObservations,
        reason,
        anotherReason: this.otherReason,
        ticket: this.newTicket,
        time: `${this.dates0[0]} 00:00:00`
      }
      // console.log('updateVehicleStatus', data)
      this.updateVehicleCondition(data)
    },
    clearSearch() {
      this.searchAction = false
      this.searchVehicleResult = []
    },
    searchVehicle() {
      // console.log('SEARCH', this.searchVehicleValue)
      if (this.searchVehicleValue !== null) {
        this.searchAction = false
        this.searchVehicleAction(this.searchVehicleValue)
          .then(result => {
            // this.searchVehicleValue = null
            this.searchAction = true
            this.$refs.search.reset()
            this.searchVehicleResult = result
            // console.log('RESULT', this.searchVehicleResult)
            // Set log with the search result
            if (this.searchVehicleResult.length > 0) {
              const payload = {
                event: 'searched',
                eventDescription: 'finder',
                dataAction: result[0],
                modelId: result[0].id,
                modelType: 'vehicles-log',
                product: 'front-preloaded-data-search'
              }
              this.setLogHistoryFront(payload)
            }
          })
      }
    },
    chipSerialChange(value) {
      if (value === 'Si') this.chipSerialSelected = true
      else this.chipSerialSelected = false
    },
    updateVehicleDataPre() {
      const validF1 = this.$refs.form1.validate()
      const validF2 = this.$refs.form2.validate()
      if (validF1 && validF2) {
        this.updateVehicleData()
      } else {
        this.showErrorMessage = true
        this.errorMessage = 'Hay varios campos sin llenar'
      }
    },
    async editVehicle(vehicle) {
      // console.log('ACTIVE :', this.$refs.treeref.active, this.$refs.treeref)
      // this.$refs.treeref.active = []
      this.agencySelectedAction(null)

      const data = {
        nameA: 'showSuccessMessageUp',
        nameM: 'successMessageUp',
        show: false,
        message: ''
      }
      this.$store.commit(types.CONTROL_MESSAGE, data)

      this.showErrorMessage = false
      this.errorMessage = ''
      this.vehicleName = vehicle.id
      this.licensePlateEdit = vehicle.licensePlate
      this.codeEdit = vehicle.code

      await this.fetchVehicleById(vehicle.id)
      this.validStatus = this.vehicleData.status.translatedName
      // console.log('selectedVehicle', this.getSelectedVehicle)
    },
    isAlphaNumeric(evt) {
      // Only accepts alphanumeric
      // console.log('IS ALPHANUMERIC', evt.key)
      let charCode = (evt.which) ? evt.which : evt.keyCode
      if ((charCode > 31 && (charCode < 48 || charCode > 57) && (charCode < 65 || charCode > 90) && (charCode < 97 || charCode > 122) )) {
        evt.preventDefault()
      } else {
        return true
      }
    },
    isNumber(evt) {
      // evt = (evt) ? evt : window.event
      let charCode = (evt.which) ? evt.which : evt.keyCode
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault()
      } else {
        return true
      }
    }
  },
  filters: {
    upperCase: function(value) {
      // console.log('UPPER CASE', value)
      const _value = value.toUpperCase()
      // console.log('_VALUE', _value)
      return _value
    }
  },
  created() {
    this.$store.dispatch('fetchDefaultReasons')
    this.$store.dispatch('fetchValidStatuses')
  }
}
</script>


<style lang="stylus" scoped>
h2
  font-size 36px
  font-weight 500

h3
  font-size 30px
  font-weight 500

h4
  font-size 46px
  font-weight 500
  color grey

h5
  font-size 16px
  font-weight 400

h6
  font-size 14px
  font-weight 400

.message-historial
  background-color #212121
  border-radius 2px

.bg-row
  background-color rgba(255, 255, 255, 0.07)
  border-radius 2px

.col-h-1
  width 150px

.col-h-2
  width 86px

.col-h-3
  width 127px

.historical-cotainer-main
  height calc(100vh - 220px)
  overflow-y auto

.binnacle-cotainer-main
  height calc(100vh - 300px)
  overflow-y auto

.histories-container
  // min-height calc(100vh - 700px)
  max-height 230px
  background-color #212121
  border-radius 2px
  overflow-y auto

.container-expansion
  background-color #212121
  border-radius 2px

.icon-width
  max-width fit-content

.edit-status
  background-color #757575
  border-radius 2px
  color #FAFAFA
  
.current-status
  background-color #FFB300
  border-radius 2px
  color #424242

.container-operational-state
  background-color #212121
  border-radius 2px

.line-left
  border-left solid 2px white

.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.h7
  font-size 18px
  font-weight 500

.h5-ext
  font-size 16px
  font-weight 600

.agency-style
  background-color #757575
  border-radius 2px
  padding-left 15px
  padding-bottom 7px

.big-icon
  margin-left -30px

.chip-info-style
  width fit-content
  margin-right 10px

.chip-info-style-text
  width 377px

.title-2
  width fit-content

.tag-loading
  background-color rgba(255, 179, 0, 0.75)
  border-radius 2px
  color #424242
  font-size 16px
  font-weight 700

.tag-id-mini
  background-color #E0E0E0
  border-radius 2px
  padding-left 10px
  padding-right 10px
  color #424242
  font-size 14px
  font-weight 600
  width fit-content

.tag-id
  background-color #FFB300
  border-radius 2px
  padding-left 10px
  padding-right 10px
  color #424242
  font-size 21px
  font-weight 700
  width fit-content

.list-vehicles
  height calc(100vh - 570px)
  overflow-y scroll  

.edit-color
  background-color #FFB300
  padding-left 5px
  padding-right 5px
  border-radius 2px
  color #424242

.layout
  max-width 1070px

.general-bg
  background-color #424242
  border-radius 3px

.section-1
  min-width 360px
  // margin-left 10px 

.section-2
  min-width 680px
  margin-left 10px

.section-3
  background-color #2F2F2F
  border-radius 3px

.section-4
  min-width 500px
  margin-left 10px
  
.header-vehicle
  height 30px
  background-color #212121
  margin-bottom 1px

.title-list-container
  background-color #212121

.info-vehicle
  background-color #212121
  height 40px
  margin-bottom 1px

.info-vehicle-r
  background-color #616161
  height 40px
  margin-bottom 1px
  border-radius 2px

.plate-border
  border 2px solid grey
  border-radius 5px

.pointer-1
  cursor pointer

.pointer-1:hover
  opacity 0.7

.missing-init-pos
  color red
  border-top red 1px solid

</style>




// WEBPACK FOOTER //
// src/components/VehicleCRUD.vue